import * as colorStyles from '../../../../colors/colors.css';
import * as backgroundStyles from '../../../../colors/backgrounds.css';
export function getColorProps(color) {
  var className = colorStyles["color_".concat(color)];
  if (className) {
    return {
      className: className
    };
  }
  return {
    style: {
      color: color
    }
  };
}
export function getBackgroundProps(background) {
  var className = backgroundStyles["background_".concat(background)];
  if (className) {
    return {
      className: className
    };
  }
  return {
    style: {
      background: background
    }
  };
}